export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-12 md:py-16 lg:py-0">
          <div className="flex-1 w-full text-center lg:text-left space-y-5">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide whitespace-nowrap">
              <i className="ri-fire-fill text-sm"></i>
              每日更新 · 全网最快吃瓜平台
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight tracking-tight">
              17吃瓜网
              <span className="block text-primary-500">最新黑料资源一站式平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 font-heading font-medium">
              百万瓜友的选择 · 每日吃瓜就上17吃瓜网
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              <strong>17吃瓜网</strong>汇聚全网最新<strong>吃瓜在线</strong>内容与<strong>吃瓜资源</strong>，每日24小时不间断追踪娱乐圈、网红圈、社会热点等各类<strong>最新黑料</strong>与热门话题。无论是<strong>APP下载</strong>随身吃瓜，还是通过<strong>吃瓜网站</strong>首页入口浏览，<strong>17一起吃瓜网</strong>致力于为每一位瓜友提供最快、最全、最真实的吃瓜体验。当前热门：明星恋情实锤追踪、顶流网红翻车合集、综艺幕后大揭秘。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm">
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                <span>每日更新 <strong className="text-foreground-900">50+</strong> 条内容</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                <span>覆盖 <strong className="text-foreground-900">30+</strong> 话题分类</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                <span>7×24小时 <strong className="text-foreground-900">不间断</strong> 追踪</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 pt-2">
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 text-sm"
              >
                <i className="ri-download-2-line text-lg"></i>
                立即下载APP
              </a>
              <a
                href="#updates"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-700 font-medium rounded-lg hover:border-primary-300 hover:text-primary-600 hover:bg-primary-50/50 transition-all duration-200 text-sm"
              >
                <i className="ri-arrow-right-line text-lg"></i>
                浏览最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-br from-primary-400/20 to-accent-400/20 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20digital%20illustration%20of%20trending%20entertainment%20news%20and%20social%20media%20buzz%2C%20abstract%20visualization%20of%20viral%20content%20spreading%2C%20warm%20coral%20and%20amber%20gradients%2C%20modern%20editorial%20style%2C%20clean%20composition%2C%20professional%20news%20platform%20aesthetic%2C%20soft%20glowing%20elements%2C%20Chinese%20entertainment%20media%20vibe&width=800&height=600&seq=hero-main-2026&orientation=landscape"
                alt="17吃瓜网 - 最新吃瓜黑料资源平台"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="800"
                height="600"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}